export default __webpack_public_path__ + "static/media/notetakermainpng.c6ec036c.png";